import { render, staticRenderFns } from "./NewsletterPage.vue?vue&type=template&id=b20f29f6&scoped=true&"
import script from "./NewsletterPage.vue?vue&type=script&lang=js&"
export * from "./NewsletterPage.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterPage.vue?vue&type=style&index=0&id=b20f29f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20f29f6",
  null
  
)

export default component.exports